import { BrandRepository, UpdateBrandInput } from '../../domain/repositories/brand.repository';
import { BrandEntity } from '../../domain/entities/brand.entity';

export class UpdateBrandUseCase {
  constructor(private readonly brandRepository: BrandRepository) {}

  async execute(id: string, data: UpdateBrandInput): Promise<BrandEntity> {
    return this.brandRepository.updateBrand(id, data);
  }
}
